<template>
    <component
        :is="self ? 'MkA' : 'a'"
        ref="el"
        class="ieqqeuvs _link"
        :[attr]="self ? props.url.substring(local.length) : props.url"
        :rel="rel"
        :target="target"
        @contextmenu.stop="() => {}"
        @click.stop
    >
        <template v-if="!self">
            <span class="schema">{{ schema }}//</span>
            <span class="hostname">{{ hostname }}</span>
            <span v-if="port != ''" class="port">:{{ port }}</span>
        </template>
        <template v-if="pathname === '/' && self">
            <span class="self">{{ hostname }}</span>
        </template>
        <span v-if="pathname != ''" class="pathname">{{
            self ? pathname.substring(1) : pathname
        }}</span>
        <span class="query">{{ query }}</span>
        <span class="hash">{{ hash }}</span>
        <mg-icon
            v-if="target === '_blank'"
            icon="arrow-square-out"
            class="icon"
            size="sm"
        />
    </component>
</template>

<script lang="ts" setup>
import { defineAsyncComponent, useTemplateRef } from "vue";
import { toUnicode as decodePunycode } from "punycode/";
import { url as local } from "@/config";
import { useTooltip } from "@/composables/use-tooltip";
import MkA from "@/components/global/MkA.vue";

import { spawnPopover } from "@/components/layout/popover-layer";

const props = defineProps<{
    url: string;
    rel?: string;
}>();

const self = props.url.startsWith(local);
const url = new URL(props.url);
if (!["http:", "https:"].includes(url.protocol)) {
    throw new Error("invalid url");
}

const el = useTemplateRef<HTMLElement | InstanceType<typeof MkA>>("el");

useTooltip(el, (showing) => {
    spawnPopover(
        defineAsyncComponent(
            () => import("@/components/MkUrlPreviewPopup.vue"),
        ),
        {
            url: props.url,
            source: el.value,
        },
        undefined,
        showing,
    );
});

const prettyUri = (str: string) => {
    try {
        return decodeURI(str);
    } catch {
        return str;
    }
};

const schema = url.protocol;
const hostname = decodePunycode(url.hostname);
const port = url.port;
const pathname = prettyUri(url.pathname);
const query = prettyUri(url.search);
const hash = prettyUri(url.hash);
const attr = self ? "to" : "href";
const target = self ? null : "_blank";
</script>

<style lang="scss" scoped>
.ieqqeuvs {
    word-break: break-all;

    > .icon {
        padding-left: 2px;
        font-size: 0.9em;
        vertical-align: super;
    }

    > .self {
        font-weight: bold;
    }

    > .schema {
        opacity: 0.5;
    }

    > .hostname {
        font-weight: bold;
    }

    > .pathname {
        opacity: 0.8;
    }

    > .query {
        opacity: 0.5;
    }

    > .hash {
        font-style: italic;
    }
}
</style>
